import numeral from 'numeral'
import _ from 'lodash'

const WAYPOINT_TYPE_DEFAULT = 0
const WAYPOINT_TYPE_EXC = -1
const WAYPOINT_TYPE_REQUIRED = 1

const WAYPOINT_CONFIG = ['1']

// 避开海盗绕航
const EXC_WAYPOINT_DEFAULT_ARR = [-2, 19665, 53829, 13567, 25091, 22445, 61705]

// 路由点的符号
const ROUTESYMBOLS = [
  {
    type: 'simple-marker',
    size: 14,
    color: [150, 0, 0, 0.6],
    outline: {
      color: [150, 0, 0, 0],
      width: 2
    }
  },
  {
    type: 'simple-marker',
    size: 12,
    style: 'cross',
    color: [150, 0, 0, 1],
    outline: {
      color: [150, 0, 0, 1],
      width: 6
    }
  },
  {
    type: 'simple-marker',
    style: 'x',
    size: 10,
    color: [100, 0, 0, 1],
    outline: {
      color: [100, 0, 0, 1],
      width: 6
    }
  }
]

/*
  创建港口点要素图层
*/
var createFeatureLayer = function (FeatureLayer, config = {}) {
  const layer = new FeatureLayer({
    id: config.id,
    supportsEditing: true,
    supportsAdd: true,
    source: [],
    fields: [
      { name: 'ObjectID', alias: 'ObjectID', type: 'oid' },
      { name: 'portId', alias: 'portId', type: 'string' },
      { name: 'portName', alias: 'portName', type: 'string' },
      { name: 'UUID', alias: 'UUID', type: 'string' }
    ],
    objectIdField: 'ObjectID',
    renderer: {
      type: 'simple',
      symbol: {
        type: 'simple-marker',
        color: [50, 60, 200, 0.8],
        size: 11,
        outline: {
          width: 1.3,
          color: 'white'
        }
      }
    },
    spatialReference: {
      wkid: 102100
    },
    geometryType: 'point',
    labelingInfo: [
      {
        labelExpressionInfo: {
          expression: '$feature.portName'
        },
        labelPlacement: 'above-center',
        symbol: {
          type: 'text',
          color: [161, 68, 59, 1],
          font: {
            size: 10,
            weight: 'bold'
          }
        }
      }
    ]
  })

  return layer
}

/*
  创建单个港口点
*/
var makePortPoint = function (mapView, featureLayer, port) {
  if (!_.isObject(port)) return
  var feature = {
    geometry: {
      type: 'point',
      longitude: port.lon,
      latitude: port.lat
    },
    attributes: {
      portId: port.PortID,
      portName: port.PortName
    }
  }

  setTimeout(() => {
    const promise = featureLayer.applyEdits({
      addFeatures: [feature]
    })
  }, 200)

  try {
    mapView.goTo({
      center: [port.lon, port.lat],
      zoom: 5
    })
  } catch (error) {
    console.log(error)
  }
}

export default {
  createFeatureLayer,
  makePortPoint,
  ROUTESYMBOLS,
  WAYPOINT_TYPE_DEFAULT,
  WAYPOINT_TYPE_EXC,
  WAYPOINT_TYPE_REQUIRED,
  EXC_WAYPOINT_DEFAULT_ARR,
  WAYPOINT_CONFIG

}
